import React from "react";
import RefinementList from "components/search/base/RefinementList";
import literaryPeriodCategories from "components/search/references/literaryPeriodCategories";

const LiteraryPeriodRefinementList = () => {
  return (
    <RefinementList
      attribute="literaryPeriod"
      categories={literaryPeriodCategories}
      limit={100}
      refinementLimit={3}
      title="Literary Period"
    />
  );
};

export default LiteraryPeriodRefinementList;
